import FooterReinsurance from '../FooterReinsurance';

const LightFooter: React.FC = () => {
  return (
    <>
      <footer>
        <div className="limited-width-container">
          <FooterReinsurance />
        </div>
      </footer>
      <style jsx>{`
        footer {
          background-color: var(--clr-primary-5);
          padding: var(--space-6); var(--padding-layout-horizontal-sm);
        }
      `}</style>
    </>
  );
};

export default LightFooter;
